import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { useDispatch, useSelector } from 'react-redux';
import { setContainerFloors, setSelectedFloor } from '../Reducers/Configurator/Actions';
import { getContainer, getSelectedFloor } from '../Reducers/Configurator/Selectors';
import Typography from '@material-ui/core/Typography';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';

const useStyles = makeStyles(
  (theme) => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
    },
    label: {
      cursor: 'pointer',
      fontSize: '2em',
    },
    boldLabel: {
      cursor: 'pointer',
      fontWeight: 'bold',
      fontSize: '2em',
    },
  }),
  { name: 'FloorSelection' }
);

export const FloorSelection = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const container = useSelector(getContainer);
  const selectedFloor = useSelector(getSelectedFloor);
  const onChangeFloor = (floor: number) => {
    dispatch(setSelectedFloor(floor));
  };
  if (container.floors === 1) {
    return null;
  }

  return (
    <div className={classes.container}>
      <Typography
        onClick={() => onChangeFloor(0)}
        className={selectedFloor === 0 ? classes.boldLabel : classes.label}
      >
        {t('floorSelection.floor0')}
      </Typography>
      {container.floors > 1 && (
        <Typography
          onClick={() => onChangeFloor(1)}
          className={selectedFloor === 1 ? classes.boldLabel : classes.label}
        >
          {t('floorSelection.floor1')}
        </Typography>
      )}
      {container.floors > 2 && (
        <Typography
          onClick={() => onChangeFloor(2)}
          className={selectedFloor === 2 ? classes.boldLabel : classes.label}
        >
          {t('floorSelection.floor2')}
        </Typography>
      )}
    </div>
  );
};

export default FloorSelection;
